import { combineReducers } from 'redux'
import {
  ACL_GET_ACTION_ERROR,
  ACL_GET_ACTION_LOADING,
  ACL_GET_ACTION_SUCCESS,
  ACL_SET_ERROR,
  ACL_SET_LOADING,
  ACL_SET_SUCCESS
} from 'actions/constant'

const aclGetActionError = (state = false, action) => {
  switch (action.type) {
    case ACL_GET_ACTION_ERROR:
      return action.aclGetActionError
    default:
      return state
  }
}

const aclGetActionLoading = (state = false, action) => {
  switch (action.type) {
    case ACL_GET_ACTION_LOADING:
      return action.aclGetActionLoading
    default:
      return state
  }
}

const aclGetActionSuccess = (state = false, action) => {
  switch (action.type) {
    case ACL_GET_ACTION_SUCCESS:
      return action.aclGetActionSuccess
    default:
      return state
  }
}

const actions = (state = [], action) => {
  switch (action.type) {
    case ACL_GET_ACTION_SUCCESS:
      return action.actions
    default:
      return state
  }
}

const setAclError = (state = false, action) => {
  switch (action.type) {
    case ACL_SET_ERROR:
      return action.setAclError
    default:
      return state
  }
}

const setAclLoading = (state = false, action) => {
  switch (action.type) {
    case ACL_SET_LOADING:
      return action.setAclLoading
    default:
      return state
  }
}

const setAclSuccess = (state = false, action) => {
  switch (action.type) {
    case ACL_SET_SUCCESS:
      return action.setAclSuccess
    default:
      return state
  }
}

const aclReducer = combineReducers({
  aclGetActionError,
  aclGetActionLoading,
  aclGetActionSuccess,
  actions,

  setAclError,
  setAclLoading,
  setAclSuccess
})

export default aclReducer
